<div class="title">
  <div class="coldx ">
    <h4 *ngIf="action !== 'TRANSFER'">{{memberSelected ? 'Modifica Membro' : 'Associa membro'}}</h4>
    <h4 *ngIf="action === 'TRANSFER'">Trasferisci membro</h4>
  </div>
</div>

<form [formGroup]="form">

  <div class="row">
    <div class="col-12">
      <div class="panel panel-default">
        <div class="panel-heading">Società e dipartimento {{memberSelected ? 'di appartenenza' : 'selezionate'}}</div>
        <div class="panel-body">
          <h5><strong>Società :</strong> {{departmentSelected ? departmentSelected.company.name : ''}}</h5>
          <h5><strong>Dipartimento :</strong> {{departmentSelected ? departmentSelected.description : ''}}</h5>
        </div>
      </div>
    </div>
  </div>

  <app-search-person *ngIf="action === 'SAVE'" [listPersonID]="listMembersID" [labelTitle]="'Ricerca persona'"
    [required]="true" (onSelect)="retrievePerson($event)"></app-search-person>

  <div *ngIf="personSelected && (action === 'EDIT' || action === 'SAVE') " class="panel panel-default">
    <div class="panel-body">
      <div checkBoxRadio class="col-sm-6" [labelInput]="'Responsabile di dipartimento ?'" idInput="isInChargeOf"
        [objectReference]="isInChargeOf" (onReturn)="isInChargeOf = $event ; initForm()"></div>
    </div>
  </div>

  <app-search-role-department *ngIf="action === 'EDIT' || action === 'SAVE'" [required]="true"
    (onSelect)="retrieveRole($event)"></app-search-role-department>


  <div *ngIf="personSelected || roleSelected" class="row mx-20 d-flex justify-content-center">
    <table class="w-100">
      <caption class="sr-only">Tabella membri</caption>
      <tr class="border rounded-top">
        <th class="cell-info-recup">Persona selezionata</th>
        <th *ngIf="personSelected && personSelected.type === 'PHYSICAL_ENTITY'" class="tg-oy1f cell-info-selected">
          <h5>{{personSelected.lastName}} {{personSelected.firstName}} </h5>
        </th>
        <th *ngIf="personSelected && personSelected.type === 'LEGAL_ENTITY'" class="tg-oy1f cell-info-selected">
          <h5>{{personSelected.name}}</h5>
        </th>
        <th *ngIf="personSelected" class="tg-oy1"><span style="text-align: center;color:#0b59a4;cursor: pointer;"
            class="glyphicon glyphicon-trash" *ngIf="action === 'SAVE'" (click)="deletePerson()"></span></th>
      </tr>
      <tr class="border rounded-bottom">
        <th class="cell-info-recup">Ruolo selezionato</th>
        <th class="tg-oy1f cell-info-selected">
          <h5>{{roleSelected ? roleSelected.description : ''}}</h5>
        </th>
        <th *ngIf="roleSelected" class="tg-oy1"><span style="text-align: center;color:#0b59a4;cursor: pointer;"
            class="glyphicon glyphicon-trash" *ngIf="action === 'EDIT' || action === 'SAVE'"
            (click)="deleteRole()"></span></th>
      </tr>
    </table>
  </div>

  <div *ngIf="action === 'TRANSFER'" class="row mx-20 d-flex justify-content-center mt-20">
    <div class="form-group w-100">
      <label for="company">Seleziona il dipartimento su cui trasferire il membro</label> <span
        class="mandatory ">*</span>
      <select (ngModelChange)="changeDepartment($event)" class="form-control" type="text" formControlName="department">
        <option [ngValue]="null">Seleziona un dipartimento</option>
        <option *ngFor="let department of departments " [title]="department.name" [ngValue]="department">
          {{department.name}} ( Società : {{department.company.name}} )
        </option>
      </select>
    </div>
  </div>

  <p class="col-md-12 mt-10 mandatory"><em>* Campi obbligatori</em></p>
  <div class="form-row">
    <div class="col-xs-12 col-sm-6"></div>

    <div class="col-sm-3 col-xs-6"> <button class="btn btn-outline-secondary btn-block" (click)="formReset()">Reset</button>
    </div>
    <div *ngIf="action !== 'TRANSFER'" class="col-sm-3 col-xs-6"> <button (click)="onSave()" [disabled]="!form.valid"
        class="btn btn-primary btn-block   ">{{memberSelected ? 'Salva' : 'Associa'}}</button> </div>
    <div *ngIf="action === 'TRANSFER'" class="col-sm-3 col-xs-6"> <button (click)="onSave()" [disabled]="!form.valid"
        class="btn btn-primary btn-block   ">Trasferisci</button> </div>
  </div>

</form>